"use client";

import { HeartHandshake } from "lucide-react";
import Image from "next/image";

interface PartnersSectionProps {
  partners: {
    title: string;
    subtitle?: string;
    items: Array<{ name: string; imgUrl: string; description?: string }>;
  };
}

const PartnersSection = ({ partners }: PartnersSectionProps) => {
  if (!partners?.items?.length) return null;
  return (
    <section className="w-full bg-white py-[3rem] md:py-[5rem] px-[1rem] md:px-[2rem]">
      <div className="mx-auto w-full max-w-[120rem]">
        <div className="mb-[3rem] md:mb-[4rem] text-center">
          <h2 className="text-[2rem] sm:text-[2.5rem] md:text-[3rem] lg:text-[4rem] font-bold text-tertiary mb-[1rem] px-[1rem]">
            {partners.title}
          </h2>
          {partners.subtitle && (
            <p className="mx-auto max-w-[55rem] text-[1rem] sm:text-[1.2rem] md:text-[1.5rem] leading-relaxed text-font px-[1rem]">
              {partners.subtitle}
            </p>
          )}
        </div>
        <div className="mx-auto grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 md:gap-8">
          {partners.items.map((item) => (
            <article
              key={item.name}
              className="group flex h-full min-w-0 flex-col overflow-hidden rounded-[1.5rem]  bg-primary shadow-[0_4px_16px_rgba(11,48,74,0.08)] transition-[transform,box-shadow,border-color] duration-300 hover:border-tertiary/40 hover:shadow-[0_16px_36px_rgba(11,48,74,0.16)] motion-safe:hover:-translate-y-1"
            >
              <div className="flex w-full items-center justify-center bg-white p-5 md:p-6">
                <div className="w-full  overflow-hidden rounded-[1.25rem] shadow-[0_8px_20px_rgba(11,48,74,0.12)] ring-1 ring-tertiary/10">
                  {item.imgUrl ? (
                    <Image
                      src={item.imgUrl}
                      alt={item.name}
                      width={544}
                      height={364}
                      sizes="272px"
                      className="block h-auto w-full rounded-[1.25rem]"
                    />
                  ) : (
                    <div className="flex aspect-[3/2] items-center justify-center rounded-[1.25rem] bg-white text-tertiary">
                      <HeartHandshake
                        size={40}
                        strokeWidth={1.5}
                        aria-hidden="true"
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="w-full min-w-0 flex-1 bg-primary p-5 text-start md:p-6">
                <div className="h-full border-s-[3px] border-secondary ps-4">
                  <h3 className="text-lg md:text-xl font-bold leading-8 text-white break-words">
                    {item.name}
                  </h3>
                  {item.description && (
                    <p className="mt-2 text-sm md:text-base leading-7 text-white/80">
                      {item.description}
                    </p>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
export default PartnersSection;
